/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Turntable = [
  ["path", { d: "M10 12.01h.01" }],
  ["path", { d: "M18 8v4a8 8 0 0 1-1.07 4" }],
  ["circle", { cx: "10", cy: "12", r: "4" }],
  ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2" }]
];

export { Turntable as default };
//# sourceMappingURL=turntable.js.map
